export default __webpack_public_path__ + "app/components/infoPanel/accountInfoPanel.html";